import { useEffect, useSyncExternalStore } from "react";
import { toast } from "react-toastify";

import { useAuth } from "context/AuthContext/AuthProvider";
import { useChainId as useDisplayedChainId } from "lib/chains";
import { helperToast } from "lib/helperToast";
import useWallet from "lib/wallets/useWallet";

import { INVALID_NETWORK_TOAST_ID, getInvalidNetworkToastContent } from "components/Errors/errorToasts";

const toastSubscribe = (onStoreChange: () => void): (() => void) => {
  const cleanup = toast.onChange(({ id }) => {
    if (id === INVALID_NETWORK_TOAST_ID) {
      onStoreChange();
    }
  });

  return cleanup;
};

const toastGetSnapshot = () => toast.isActive(INVALID_NETWORK_TOAST_ID);

export function useRealChainIdWarning() {
  const { active: isConnected } = useWallet();
  const { chainId: displayedChainId, isConnectedToChainId } = useDisplayedChainId();
  const { isSignInModalOpen } = useAuth();

  const isActive = useSyncExternalStore(toastSubscribe, toastGetSnapshot);

  useEffect(() => {
    // Keep focus on SIWE while the sign-in modal is open.
    if (isSignInModalOpen) {
      if (isActive) {
        toast.dismiss(INVALID_NETWORK_TOAST_ID);
      }
      return;
    }

    if (!isConnectedToChainId && !isActive && isConnected) {
      helperToast.error(getInvalidNetworkToastContent(displayedChainId), {
        toastId: INVALID_NETWORK_TOAST_ID,
        autoClose: false,
        closeButton: false,
        delay: 2000,
      });
    } else if ((isConnectedToChainId || !isConnected) && isActive) {
      toast.dismiss(INVALID_NETWORK_TOAST_ID);
    }
  }, [displayedChainId, isActive, isConnected, isConnectedToChainId, isSignInModalOpen]);

  useEffect(() => {
    return () => {
      toast.dismiss(INVALID_NETWORK_TOAST_ID);
    };
  }, []);
}
